import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReferenceDocumentService {

  constructor(private http:HttpClient) { }

  uploadDoc( moduleType: Number, mediaFile: File, projectId: number): Observable<any> {
    const formData: any = new FormData();
    formData.append("projectId", projectId);
    formData.append("moduleId", moduleType);
    formData.append("media", mediaFile);
    return this.http.post(environment.baseUrl + '/transactions/api/customType/uploadAttributeRefDoc', formData);
  }
}
